"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDragSliderState = exports.DragSliderContext = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
exports.DragSliderContext = React.createContext(null);
const useDragSliderState = () => React.useContext(exports.DragSliderContext);
exports.useDragSliderState = useDragSliderState;
